import gsap from 'gsap/gsap-core';
import TweenLite from 'gsap/gsap-core';
import CSSPlugin from 'gsap/CSSPlugin';
import Draggable from 'gsap/Draggable';
import InertiaPlugin from 'gsap/InertiaPlugin';
import EventBus from '../../utils/EventBus';

gsap.registerPlugin(CSSPlugin);
gsap.registerPlugin(Draggable);
gsap.registerPlugin(InertiaPlugin);

export default {
    props: {
        config: {}
    },
    data: function() {
        return {
            position: 0,
            slideWidth: 0,
            slides: [],
            totalSlides: null,
            isDraggable: false,
            isDragging: false,
            isReady: false,
        }
    },
    computed: {
        hasNext() {
            return ((this.position + 1) < this.totalSlides);
        },
        hasPrev() {
            return (this.position > 0);
        },
        hasNav() {
            return this.totalSlides > 1;
        }
    },
    methods: {
        nextSlide() {
            if(this.setPosition(this.position + 1)) {
                this.tweenToPosition();
            }

            this.$emit('changeSlide', Object.assign({}, this.config.eventData, {
                id: this.$el.id,
                direction: 1,
                position: this.position,
                totalSlides: this.totalSlides
            }));
        },
        prevSlide() {
            if(this.setPosition(this.position - 1)) {
                this.tweenToPosition();
            }

            this.$emit('changeSlide', Object.assign({}, this.config.eventData, {
                id: this.$el.id,
                direction: -1,
                position: this.position,
                totalSlides: this.totalSlides
            }));
        },
        goToSlide(toPosition) {
            if(this.setPosition(toPosition)) {
                this.tweenToPosition();
            }
        },
        setPosition(toPosition) {
            if(toPosition >= 0 && toPosition < this.totalSlides) {
                // When someone navigates to a certain item using dots
                if (!this.isActiveSlide(toPosition)) {
                    this.activateSlide(toPosition);
                }

                // Also preload next item
                this.activateSlide(toPosition + 1);

                // Set new position
                this.position = toPosition;

                // Confirm we have updated position
                return true;
            }

            // Confirm we have not modified position
            return false;
        },
        isCurrent(position) {
            return this.position === position;
        },
        tweenToPosition() {
            TweenLite.to(this.carouselSlider, .5, {x: (this.position * -1) * this.slideWidth});
        },
        updateDimensions() {
            let slideBoundingRect = this.carouselSlider.children[0].getBoundingClientRect();

            this.sliderWidth = this.carouselSlider.offsetWidth;
            this.slideWidth = slideBoundingRect.width;

            if(typeof this.draggable !== 'undefined') {
                this.draggable.applyBounds({
                    minX: -(this.slideWidth * (this.totalSlides - 1)),
                    maxX: 0,
                });
            }
        },
        isActiveSlide(position) {
            return this.slides[position].isActive === true;
        },
        activateSlide(position) {
            if(position < this.totalSlides) {
                this.slides[position].isActive = true;

                this.$nextTick(function () {
                    if (typeof window.picturefill === 'function') {
                        window.picturefill(this.carouselSlider.children[position]);
                    }
                });
            }
        },
        setImageLoaded(position) {
            this.isReady = (this.isReady === true) ? this.isReady : position === 0;
        }
    },
    created() {
        // Store slide config inside component
        this.slides = this.config.slides.map((item, index) => {
            item.isActive = index <= 1; // Load the first two slides
            return item;
        });

        // Store the amount of slides
        this.totalSlides = this.slides.length;

        // Exit if there's no need for slider
        if(this.totalSlides <= 1) {
            return;
        }

        // Set onResize handler
        EventBus.$on('Responsive:onResize', () => {
            this.updateDimensions();

            this.tweenToPosition();
        });
    },
    mounted() {
        this.carouselTarget = this.$refs.carouselTarget;
        this.carouselSlider = this.$refs.carouselSlider;

        if (typeof window.picturefill === 'function') {
            window.picturefill(this.carouselSlider);
        }

        // Don't initiate draggable if it's a single item
        if (this.totalSlides <= 1) {
            this.isReady = true;
            return;
        }

        this.$nextTick(function () {
            // Set initial dimensions
            this.updateDimensions();

            // Set draggable
            this.isDraggable = window.Modernizr && window.Modernizr.touch;
            if (this.isDraggable) {
                // Initiate GSAP draggable
                this.draggable = Draggable.create(this.carouselSlider, {
                    trigger: this.carouselTarget,
                    type: 'x',
                    cursor: 'unset',
                    bounds: {
                        maxX: 0,
                        minX: -(this.slideWidth * (this.totalSlides - 1))
                    },
                    snap: {
                        x: function (endValue) {
                            let newPosition = Math.round(endValue / this.slideWidth) * -1;

                            if (newPosition < 0) {
                                return 0;
                            } else {
                                if (this.setPosition(newPosition)) {
                                    return Math.round(endValue / this.slideWidth) * this.slideWidth;
                                } else {
                                    return Math.round(this.position * -1) * this.slideWidth;
                                }
                            }
                        }.bind(this)
                    },
                    inertia:true,
                    minDuration: 0.1,
                    maxDuration: 0.3,
                    throwResistance: 100,
                    zIndexBoost: false,
                    onDragStart: function () {
                        this.isDragging = true;
                    }.bind(this),
                    onDragEnd: function () {
                        this.isDragging = false;
                    }.bind(this)
                })[0];
            }
        });
    }
}
